import React from 'react'
import { ListItem } from 'material-ui/List'
import Notifications from 'material-ui/svg-icons/social/notifications'
import SwapTextualDescription from './Swap/SwapTextualDescription'
import { themeColors } from '../styles/theme'

// Now notification is only about swap...
const NotificationsListItem = ({ user, swap }) => (
  <ListItem
    leftIcon={<Notifications color={themeColors.positive} />}
    primaryText={
      <div>
        Hai ricevuto una nuova proposta di scambio da
        {' '}
        <span style={{ color: themeColors.secondary }}>
          {swap.proponente.username}
        </span>
      </div>
    }
    secondaryText={<SwapTextualDescription swap={swap} user={user} />}
  />
)

export default NotificationsListItem



// WEBPACK FOOTER //
// ./src/common/NotificationsListItem.js